/* storybook-check-ignore */
const HamburgerMenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M20 1H6.55651e-07" stroke="#A2A2A2" strokeWidth="1.25" />
    <path d="M20 13H6.55651e-07" stroke="#A2A2A2" strokeWidth="1.25" />
    <path d="M20 7H6.55651e-07" stroke="#A2A2A2" strokeWidth="1.25" />
  </svg>
);

export default HamburgerMenuIcon;
